import React from "react";

import { Navigate, Route, Routes, useParams } from "react-router-dom";

import { MessageChannel } from "@/gql/graphql";

import Chat from "./components/Chat";
import Layout from "./components/Layout";

type RouteParams = {
  chatId: string;
};

const MessageChatPage: React.FC = () => {
  const { chatId } = useParams<RouteParams>();

  return (
    <Layout chatId={chatId ?? ""}>
      <Routes>
        <Route
          path="appointment"
          element={
            <Chat
              key={`${chatId}_${MessageChannel.Appointment}`}
              chatId={chatId ?? ""}
              channel={MessageChannel.Appointment}
            />
          }
        />
        <Route
          path="meal-plan"
          element={
            <Chat
              key={`${chatId}_${MessageChannel.MealPlan}`}
              chatId={chatId ?? ""}
              channel={MessageChannel.MealPlan}
            />
          }
        />
        <Route
          path="progress"
          element={
            <Chat
              key={`${chatId}_${MessageChannel.Progress}`}
              chatId={chatId ?? ""}
              channel={MessageChannel.Progress}
            />
          }
        />
        <Route
          path="questions"
          element={
            <Chat
              key={`${chatId}_${MessageChannel.Questions}`}
              chatId={chatId ?? ""}
              channel={MessageChannel.Questions}
            />
          }
        />
        <Route path="*" element={<Navigate to="appointment" replace />} />
      </Routes>
    </Layout>
  );
};

export default MessageChatPage;
